export default __webpack_public_path__ + "static/media/trus4.cc5225c5.png";